import { render, staticRenderFns } from "./logohome.vue?vue&type=template&id=f671b7b6&scoped=true"
import script from "./logohome.vue?vue&type=script&lang=js"
export * from "./logohome.vue?vue&type=script&lang=js"
import style0 from "./logohome.vue?vue&type=style&index=0&id=f671b7b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f671b7b6",
  null
  
)

export default component.exports